import isEmpty from 'lodash/isEmpty'

/** A customer, vendor or user's display name: the company name, or the contact's profile name when there is no company.
 * A company name that is an empty string, null or undefined falls through to the profile name — a party row carrying
 * `company: { name: '' }` still has a contact to show. A whitespace-only name is NOT empty to `isEmpty`, so it is
 * returned as it stands. */
export const getCompanyOrProfileName = (
  party?: { company?: { name?: string } | null; profile?: { name?: string } | null } | null
): string | undefined => (isEmpty(party?.company?.name) ? party?.profile?.name : party?.company?.name)
